import BaseModel from './BaseModel';

class AssetEarningsConfig extends BaseModel {
    constructor(data = {}, api_data = false) {
      super(data);
      this.index_prev_config_map = {}
      if (api_data) {
          this.setApiData(data);
      } else {
          this.updateData(data);
      }
    }

    create_index_prev_config_map = (data) => {
      data.asset_earning_configs_items.map((config_item, index) => {
        if(config_item.id) {
            return this.index_prev_config_map[config_item.id] = index;
        }
        return "";
      })
    } 

    setApiData = (data) => {
      this.id = data.id;
      this.offer_id = data.offer_id || "";
      this.rfid_type_id = data.rfid_type_id || "";
      this.create_index_prev_config_map(data);
      this.asset_earning_configs_items = data.asset_earning_configs_items.map((config_item, index)=>{
        if( config_item.previous_item_id ) {
            return { ...config_item, key: index, previous_item_key: this.index_prev_config_map[config_item.previous_item_id]}
        }
        return { ...config_item, key: index }
      });
      this.deleted_configs = data.deleted_configs || [];
    }

    updateData = (data) => {
        this.id = data.id;
        this.offer_id = data.offer_id || "";
        this.rfid_type_id = data.rfid_type_id || "";
        this.asset_earning_configs_items = data.asset_earning_configs_items || [];
        this.deleted_configs = data.deleted_configs || [];
    }

    toApiJson = () => {
      this.completeValidation();
      return {
        id: this.id,
        offer_id: this.offer_id,
        rfid_type_id: this.rfid_type_id,
        config_items_attributes: this.asset_earning_configs_items.map((config_item)=>{
            delete config_item.previous_item_id;
            return config_item
        }).concat(this.deleted_configs)
      }
    }

    validations = (field) => {
      return {
        offer_id: () => {
          if (this[field] === "") {
            this.errors.offer_id = "Please select an offer.";
          } else{
            delete this.errors.offer_id;
          }
        },
        rfid_type_id: () => {
          if (this[field] === "") {
            this.errors.rfid_type_id = "Please select the RFID type.";
          } else {
            delete this.errors.rfid_type_id;
          }
        },
        previous_item_key: () => {
          this.asset_earning_configs_items.map((config_item) => {
              if(config_item[field] < 0 || config_item[field] > this.asset_earning_configs_items.length ) {
                this.errors.previous_item_key = "Invalid previous item id";
              } else {
                delete this.errors.previous_item_key;
              }
          })
        }
      }[field];
    }

    validate = (field) => {
        if (this.validations(field)) {
            this.validations(field)()
        }
    }
}

export default AssetEarningsConfig;
